import { Fragment, useEffect, useState } from "react";

const CountdownCustom = ({ date, showDay = true, setUTCMidnight = true }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();

      const midnightUTC = new Date(now);
      midnightUTC.setUTCHours(24, 0, 0, 0); // Set to midnight UTC

      let timeDifference;

      if(!date){
       timeDifference = midnightUTC - now;
      } else {
      const eventDate = new Date((date.seconds ?? date) * 1000);
      // set hours to midnight UTC on the event date
      if(setUTCMidnight){
        eventDate.setUTCHours(0, 0, 0, 0);
      }
       timeDifference = eventDate - now;
      }
      
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((timeDifference / 1000 / 60) % 60);
      const seconds = Math.floor((timeDifference / 1000) % 60);

      if(timeDifference < 0){
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({ days, hours, minutes, seconds });
    };

    const interval = setInterval(() => {
      calculateTimeLeft();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Fragment>
      {`${showDay ? timeLeft.days + "d " : ""} `}
      {`${
        timeLeft.hours < 10 ? `0${timeLeft.hours}` : timeLeft.hours
      }:${timeLeft.minutes < 10 ? `0${timeLeft.minutes}` : timeLeft.minutes}:${
        timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : timeLeft.seconds
      }`}
    </Fragment>
  );
}

export default CountdownCustom;